import { useState } from "react";
import { VoteUsers } from "../../../components/Vote";
import { Users, WhenOption, Vote } from "../../../../types";

export function WhenOptionDetail({ users, option, isMaybeOption }: { users: Users, option: WhenOption, isMaybeOption: boolean }) {
    const [active, setActive] = useState<Vote>("yes");

    return <>
        {option.description && <p>{option.description}</p>}
        <VoteUsers users={users} votes={option.users} isMaybeOption={isMaybeOption} active={active} onChange={setActive} />
    </>;
}
